import React from "react";
import { useHistory } from "react-router-dom";

import {
  THead,
  TrHead,
  TBody,
  Th,
  Tr,
  Td,
  InnerCell,
} from "@teamrota/rota-design";

import { StreamProvider } from "@teamrota/shiftstreamlib";

import IconLink from "~/src/containers/payroll/components/IconLink";
import Icon from "~/src/components/icon";
import { EmptyText } from "~/src/components/payroll/style";

import { ScrollableTable } from "../styles";
import { COL_WIDTHS } from ".";
import { cleanAddress, toHumanDuration } from "../../utils";

interface TableProps {
  accounts: any[];
  loading: boolean;
}

const Table: React.FC<TableProps> = ({ accounts, loading }) => {
  const history = useHistory();

  const handleClickStreams = (account: any) => {
    history.push(`/shiftstream/streams/account/${account.id}`);
  };

  const handleClickEmails = (account: any) => {
    history.push(`/shiftstream/emails/account/${account.id}`);
  };

  return (
    <ScrollableTable colWidths={COL_WIDTHS}>
      <THead>
        <TrHead>
          <Th>Account ID</Th>
          <Th>Account Name</Th>
          <Th>Provider</Th>
          <Th>Last Scrape</Th>
          <Th>Last Action</Th>
          <Th>Last Algo</Th>
          <Th>Last Fulfil</Th>
          <Th>&nbsp; </Th>
        </TrHead>
      </THead>

      <TBody className="streams-table-scroll-body">
        {accounts?.length ? (
          accounts.map((account: any) => {
            return (
              <Tr key={account.id}>
                <Td>
                  <InnerCell>#{account.id}</InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {account.provider !== StreamProvider.EMAIL ? (
                      <a
                        href={account.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {account.name}
                      </a>
                    ) : (
                      <>{account.name}</>
                    )}

                    <div style={{ fontSize: "70%" }}>
                      {account.provider === StreamProvider.EMAIL ? (
                        <>
                          Email:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {cleanAddress(account.url)}
                          </span>
                        </>
                      ) : (
                        <>
                          Login:{" "}
                          <span style={{ fontWeight: "bold" }}>
                            {account.login}
                          </span>
                        </>
                      )}
                    </div>
                  </InnerCell>
                </Td>

                <Td>
                  <img
                    title={account.name}
                    src={`/images/shiftstream/${account.provider}.png`}
                    alt={`${account.provider} logo`}
                    style={{ height: 20, verticalAlign: "middle" }}
                  />
                </Td>

                <Td>
                  <InnerCell>
                    {toHumanDuration(account.metrics.lastScrape)}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {toHumanDuration(account.metrics.lastAction)}
                  </InnerCell>
                </Td>

                <Td>
                  <InnerCell>
                    {toHumanDuration(account.metrics.lastAlgo)}
                  </InnerCell>
                </Td>
                <Td>
                  <InnerCell>
                    {toHumanDuration(account.metrics.lastFulfil)}
                  </InnerCell>
                </Td>
                <Td>
                  <InnerCell>
                    <IconLink
                      name="COG"
                      size={20}
                      isButton
                      color={Icon.colors.MAIN_ORANGE}
                      tooltip="View streams"
                      onClick={() => handleClickStreams(account)}
                    />

                    {account.provider === StreamProvider.EMAIL && (
                      <IconLink
                        name="EMAIL"
                        size={20}
                        isButton
                        color={Icon.colors.MAIN_ORANGE}
                        tooltip="View Emails"
                        onClick={() => handleClickEmails(account)}
                      />
                    )}

                    {account.provider !== StreamProvider.EMAIL && (
                      <IconLink
                        name="REFRESH"
                        size={20}
                        isButton
                        color={Icon.colors.MAIN_ORANGE}
                        tooltip="Schedule a new roster scrape"
                        onClick={() => {}}
                      />
                    )}
                  </InnerCell>
                </Td>
              </Tr>
            );
          })
        ) : (
          <Tr>
            <Td colSpan={7}>
              <EmptyText>
                {!loading && "None found 👀"}
                {loading && "Loading... ⏳"}
              </EmptyText>
            </Td>
          </Tr>
        )}
      </TBody>
    </ScrollableTable>
  );
};

export default Table;
